var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMore(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.5 8.375C4.84518 8.375 5.125 8.65482 5.125 9C5.125 9.34518 4.84518 9.625 4.5 9.625C4.15482 9.625 3.875 9.34518 3.875 9C3.875 8.65482 4.15482 8.375 4.5 8.375Z",
    fill: "#030C21",
    stroke: "#030C21"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9 8.375C9.34518 8.375 9.625 8.65482 9.625 9C9.625 9.34518 9.34518 9.625 9 9.625C8.65482 9.625 8.375 9.34518 8.375 9C8.375 8.65482 8.65482 8.375 9 8.375Z",
    fill: "#030C21",
    stroke: "#030C21"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13.5 8.375C13.8452 8.375 14.125 8.65482 14.125 9C14.125 9.34518 13.8452 9.625 13.5 9.625C13.1548 9.625 12.875 9.34518 12.875 9C12.875 8.65482 13.1548 8.375 13.5 8.375Z",
    fill: "#030C21",
    stroke: "#030C21"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMore);
export default __webpack_public_path__ + "static/media/More.c7205376.svg";
export { ForwardRef as ReactComponent };